import React, {useEffect, useState, useRef} from "react";

import LinkContainer from "../../components/Shared/LinkContainer";
import VideoOverlay from "../../components/Shared/VideoOverlay";
import StyledLink from "../../components/Shared/StyledLink";
import Container from "../../components/Shared/Container";
import LinkBox from "../../components/Shared/LinkBox";
import Video from "../../components/Shared/Video";

import MoviesList from "../../MoviesList";

import { useHistory } from "react-router";

import START_SCREEN_SAFARI from '../../assets/start_screen_safari.png';

const MovieWithRedirectOnFinishView = () => {
	const [movieCompleted, setMovieCompleted] = useState(false);
	const isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
		navigator.userAgent &&
		navigator.userAgent.indexOf('CriOS') === -1 &&
		navigator.userAgent.indexOf('FxiOS') === -1;

	const [currentVideo, setCurrentVideo] = useState(1);
	const [viewStateOne, setViewStateOne] = useState(MoviesList[0]);
	const [viewStateTwo, setViewStateTwo] = useState(MoviesList[1]);
	const [nextVideo, setNextVideo] = useState(null);
	const history = useHistory();

	const firstVideoRef = useRef();
	const secondVideoRef = useRef();

	let timeoutOne, timeoutTwo;

	useEffect(() => {
		if (!viewStateOne || !viewStateTwo) {
			history.push('/')
		}
	//	eslint-disable-next-line
	}, [viewStateTwo, viewStateOne])

	useEffect(() => {
		if(viewStateTwo && viewStateOne && !isSafari) {
				if (currentVideo === 1) {
					firstVideoRef.current.play();
					secondVideoRef.current.pause();
				}
				if (currentVideo === 2) {
					secondVideoRef.current.play();
					firstVideoRef.current.pause();
				}
				return () => {
					clearTimeout(timeoutOne)
					clearTimeout(timeoutTwo)
				}
			}
	//	eslint-disable-next-line
	}, [currentVideo])

	useEffect(() => {
		if (currentVideo === 1 && nextVideo && movieCompleted) {
			setViewStateTwo(nextVideo)
			setMovieCompleted(false)
			setNextVideo(null)
		}
		if (currentVideo === 2 && nextVideo && movieCompleted) {
			setViewStateOne(nextVideo);
			setMovieCompleted(false)
			setNextVideo(null)
		}
	//	eslint-disable-next-line
	}, [currentVideo, movieCompleted])

	return (
		<Container backrgroundColor={isSafari && '#fff'}>
			{isSafari ?
				<a href={"https://umed.pl/"}>
					<Container
						justify={'center'} backgroundImage={START_SCREEN_SAFARI}
						backrgroundColor={'white'}
						cursor={'pointer'}
						align={'center'}
					/>
				</a>
				:(
				<>
				<Video
					autoplay
					playsinline
					ref={firstVideoRef}
					visible={currentVideo === 1}
					key={viewStateOne && viewStateOne.video}
					onPlay={() => setMovieCompleted(false)}
					onEnded={() => {
						timeoutOne = setTimeout(() => setCurrentVideo(2))
						if (viewStateOne.component === 'MovieWithRedirectOnFinishView') {
							const redirectElement = MoviesList.find(el => el.path === viewStateOne.redirectTo);
							if (!redirectElement) {
								clearTimeout(timeoutOne)
								clearTimeout(timeoutTwo)
								return history.push('/form')
							}
							setViewStateTwo(redirectElement);
						}
						if (viewStateOne.component === 'MovieWithButtonsView') {
							const redirectElement = MoviesList.find(el => el.path === viewStateOne.leftButton.linkTo);
							!redirectElement && history.push('/')
							if (!redirectElement) {
								clearTimeout(timeoutOne)
								clearTimeout(timeoutTwo)
								return history.push('/form')
							}
						}
						setMovieCompleted(true);
					}}
				>
					<source src={viewStateOne && viewStateOne.video} type="video/mp4"/>
				</Video>
					<Video
					autoplay
					playsinline
					key={viewStateTwo && viewStateTwo.video}
					ref={secondVideoRef}
					visible={currentVideo === 2}
					style={{position: 'absolute'}}
					onPlay={() => setMovieCompleted(false)}
					onEnded={() => {
					timeoutTwo = setTimeout(() => setCurrentVideo(1))
					if (viewStateTwo.component === 'MovieWithRedirectOnFinishView') {
						const redirectElement = MoviesList.find(el => el.path === viewStateTwo.redirectTo);
						if (!redirectElement) {
							clearTimeout(timeoutOne)
							clearTimeout(timeoutTwo)
							return history.push('/form')
						}
						setViewStateOne(redirectElement);
					}
					if (viewStateTwo.component === 'MovieWithButtonsView') {
						const redirectElement = MoviesList.find(el => el.path === viewStateTwo.leftButton.linkTo);
						if (!redirectElement) {
							clearTimeout(timeoutOne)
							clearTimeout(timeoutTwo)
							return history.push('/form')
						}
						setViewStateOne(redirectElement);
					}
					setMovieCompleted(true);
				}}
					>
					<source src={viewStateTwo && viewStateTwo.video} type="video/mp4"/>
					</Video>
					<VideoOverlay>
					<LinkContainer height={'20%'}>
					<LinkBox>
					<StyledLink
					color={'white'}
					to={'/movie'}
					size={'2rem'}
					onClick={() => {
					if (movieCompleted && viewStateOne && viewStateTwo) {
						const redirectElement = currentVideo === 1 ?
							MoviesList.find(el => el.path === viewStateOne.leftButton.linkTo) :
							MoviesList.find(el => el.path === viewStateTwo.leftButton.linkTo)
						setNextVideo(redirectElement)
					}
				}}
					>
					{currentVideo === 1 && viewStateOne && viewStateTwo ? (viewStateOne.rightButton && viewStateOne.leftButton.label) : (viewStateTwo.leftButton && viewStateTwo.leftButton.label)}
					</StyledLink>
					</LinkBox>
					<LinkBox>
					<StyledLink
					color={'white'}
					to={'/movie'}
					size={'2rem'}
					onClick={() => {
					if (viewStateOne && viewStateTwo) {
						const redirectElement = currentVideo === 1 ?
							MoviesList.find(el => el.path === viewStateOne.rightButton.linkTo) :
							MoviesList.find(el => el.path === viewStateTwo.rightButton.linkTo)
						setNextVideo(redirectElement)
					}
				}}
					>
					{currentVideo === 1 && viewStateOne && viewStateTwo ? (viewStateOne.rightButton && viewStateOne.rightButton.label) : (viewStateTwo.rightButton && viewStateTwo.rightButton.label)}
					</StyledLink>
					</LinkBox>
					</LinkContainer>
					</VideoOverlay>
				</>
			)}
		</Container>
	)
};

export default MovieWithRedirectOnFinishView;